import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { DecimalPipe } from '@angular/common';
import {
  ButtonComponent,
  InputComponent, QuantityInputComponent,
  ResolvableModal,
  TranslatePipe,
} from '@softline/ui-core';
import {
  MengenEingabeComponent,
  scan,
  ScanButtonComponent,
} from '@softline/application';
import { Bewe } from '../../types/bewegung';
import { PaletteBean } from '../../types/pallet-item';

@Component({
  selector: 'soft-pallet-detail-dialog',
  imports: [
    DecimalPipe,
    ButtonComponent,
    InputComponent,
    MengenEingabeComponent,
    ScanButtonComponent,
    TranslatePipe,
    QuantityInputComponent,
  ],
  templateUrl: './pallet-detail-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PalletDetailDialogComponent
  extends ResolvableModal<PaletteBean>
  implements OnInit
{
  static MODAL_ID = 'SOFTLINE_DIALOG_WARENUEBERNAHME_PALLET_DETAIL';

  readonly bewe = input.required<Bewe>();
  readonly palletIndex = input.required<number>();
  readonly palletCount = input.required<number>();
  readonly amount = input.required<number>();
  readonly unit = input<string | undefined>();
  // the bewe's pallet template, loaded once by the caller for all pallets
  readonly template = input<PaletteBean | null>(null);
  // values entered before an abort — take precedence over the template
  readonly initial = input<PaletteBean | null>(null);

  readonly sscc = signal<string | null>(null);
  readonly quantity = signal(0);
  readonly batchNumber = signal<string | null>(null);

  private base: PaletteBean | null = null;

  constructor() {
    super();
    scan(async (result) => this.sscc.set(result.data));
  }

  ngOnInit(): void {
    const initial = this.initial();
    this.base = this.template() ?? initial;
    this.quantity.set(initial?.menge ?? this.amount());
    this.sscc.set(initial?.sscc ?? null);
    this.batchNumber.set(this.base?.chargennummer ?? null);
  }

  confirm(): void {
    this.resolve({
      ...(this.base ?? {}),
      sscc: this.sscc()?.trim() || null,
      menge: this.quantity(),
      chargennummer: this.batchNumber()?.trim() || null,
    });
  }
}
